import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
// import * as groups from "../_metronic/_partials/dashboards/_redux/groupsRedux";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  // groups: groups.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
